import { Button, Card, Form, Input } from 'antd'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions } from '../../../../store/reducers/admin.reducer'
import { openNotificationWithIcon } from '../../../../utils/notification.helper'

const ImpersonateCard = ({ impersonate, verifyOtp }) => {
    const [form] = Form.useForm()
    const [impersonateLoading, setImpersonateLoading] = useState(false)

    const handleImpersonate = async () => {
        setImpersonateLoading(true)

        try {
            const data = await form.validateFields()

            const verifyOtpResponse = await verifyOtp(data)

            if (!verifyOtpResponse.data.valid) {
                openNotificationWithIcon('error', 'Wrong OTP!')

                return
            }

            await impersonate({ email: data.email })

            window.location.replace('/')
        } catch (error) {
            openNotificationWithIcon('error', error.response.data.detail)
        } finally {
            setImpersonateLoading(false)
        }
    }

    return (
        <Card title='Impersonate User' bordered={false} className='mb-32'>
            <Form
                form={form}
                name='impersonate-form'
                onFinish={handleImpersonate}
                layout='vertical'
                requiredMark={false}
                validateTrigger={['onBlur', 'onSubmit']}
            >
                <Form.Item
                    label='Email'
                    name='email'
                    rules={[
                        { required: true, message: "Please, input user's email" },
                        { type: 'email', message: 'Please, input valid email' },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='OTP'
                    name='otp'
                    rules={[{ required: true, message: 'Please, input OTP', validateTrigger: 'blur' }]}
                >
                    <Input.OTP style={{ width: '100%' }} type='number' />
                </Form.Item>
                <Form.Item>
                    <Button type='primary' htmlType='submit' block loading={impersonateLoading}>
                        Impersonate
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

const mapState = ({ auth }) => {
    return {
        user: auth.user,
    }
}

const mapDispatch = dispatch => {
    return {
        impersonate(data) {
            return dispatch(actions.impersonate(data))
        },
        verifyOtp(data) {
            return dispatch(actions.verifyOtp(data))
        },
    }
}

export default connect(mapState, mapDispatch)(ImpersonateCard)
